import axiosInstance from "../instance/axiosInstance";

class QuotationsApi {
  static async quotationsList(page, searchQuery) {
    let url = `/quotation/list?page=${page}`;

    if (searchQuery) {
      url += `&search_value=${encodeURIComponent(searchQuery)}`;
    }

    try {
      const response = await axiosInstance.get(url);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }

  static async deleteQuotation(id) {
    try {
      const response = await axiosInstance.get(`/quotation/delete/${id}`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async viewQuotation(id) {
    try {
      const response = await axiosInstance.get(`/quotation/view/${id}`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async createQuotation(dataObj) {
    try {
      const response = await axiosInstance.post(`/quotation/save`, dataObj);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async checkQuotationLimit() {
    try {
      const response = await axiosInstance.get(`/quotation/limit-check`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
}

export default QuotationsApi;
